"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Email;
exports.isEmail = isEmail;

function Email() {}

var regexp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

function isEmail(value) {
  return regexp.test(value);
}
//# sourceMappingURL=Email.js.map


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/commonjs/types/Email.js
// module id = 322
// module chunks = 1